import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";

import { useInvalidateToken } from "@application/services/use-invalidate-token";

// TBD replace by <Shell>
import DocumentationIcon from "@icons/documentation.svg?react";
import SignOutIcon from "@icons/signOut.svg?react";

import { Navigation } from "./Navigation";

const documentationUrl = import.meta.env.VITE_APP_DOCUMENTATION_URL as string;

export const FooterNavigation = () => {
  const { instance } = useMsal();
  const { t } = useTranslation();

  const { invalidateToken } = useInvalidateToken();

  const handleLogout = async () => {
    await invalidateToken().then(() => {
      void instance.logout();
    });
  };

  const footerItems = [
    {
      icon: <DocumentationIcon />,
      label: t("documentation.nav_item.label"),
      url: documentationUrl,
      target: "_blank",
      id: "documentation"
    },
    {
      icon: <SignOutIcon />,
      label: t("signOut.nav_item.label"),
      id: "signOut",
      url: "sign-out",
      onMenuClick: handleLogout
    }
  ];

  return <Navigation items={footerItems} />;
};
